import React from 'react';

const RETRY_DELAYS_MS = [1000, 3000];
const RELOAD_KEY = 'tracktcrm-chunk-reload-at';
const RELOAD_GAP_MS = 60 * 1000;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function isChunkLoadError(err) {
  return (
    err?.name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(String(err?.message || ''))
  );
}

/** Webpack forgets a failed chunk, so calling import() again downloads it again. */
export async function importWithRetry(factory, delays = RETRY_DELAYS_MS) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await factory();
    } catch (err) {
      if (!isChunkLoadError(err) || attempt >= delays.length) throw err;
      await wait(delays[attempt]);
    }
  }
}

export const lazyWithRetry = (factory) => React.lazy(() => importWithRetry(factory));

/**
 * After a deploy, open tabs still point at old chunk names; one reload picks up the new build.
 * Limited to once a minute so a hosting outage cannot cause a reload loop.
 */
export function reloadOnceForChunkError() {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < RELOAD_GAP_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
